import { InfoIcon } from '@/shared/ui/icons/InfoIcon'
import { AlertIcon } from '@/shared/ui/icons/AlertIcon'
import { XCloseIcon } from '@/shared/ui/icons/XCloseIcon'
import type { ProblemNewDraft } from '@/public/features/problem/types'
import { RAW_TEXT_MAX } from '@/public/features/problem/constants/problemNew'

export function StepStory({ draft }: { draft: ProblemNewDraft }) {
  return (
    <section className="flex flex-col gap-8">
      {draft.showRevisionNotice && <RevisionNotice onClose={draft.dismissRevisionNotice} />}
      <div className="flex flex-col gap-[5px]">
        <p className="m-0 text-headline-xs font-medium tracking-[-0.1px] text-black-800">
          무엇이 문제인가요?
        </p>
        <p className="m-0 text-body-md font-normal text-black-200">
          어떤 상황에서 무엇이 불편한지 30자 이상 알려주세요.
        </p>
      </div>
      <div className="flex flex-col gap-2">
      <textarea
        className="h-[420px] resize-none rounded-[14px] border border-white-400 bg-white-50 p-3.5 font-[inherit] text-body-lg text-black-600 placeholder:text-black-100"
        value={draft.rawText}
        onChange={(e) => draft.setRawText(e.target.value)}
        maxLength={RAW_TEXT_MAX}
        placeholder="예시: 혼자 사시는 부모님이 병원에 가실 때마다 이동이 어려워요. 병원까지 함께 이동할 수 있는 지원이 필요하고, 6개월 안에 도움을 받을 수 있으면 좋겠어요."
        aria-label="무엇이 문제인가요?"
      />
      <div className="flex items-center gap-0.5 [&>p:first-child]:min-w-0 [&>p:first-child]:flex-1 [&>p:first-child]:shrink-0 [&>p:first-child]:grow [&>p:first-child]:basis-0">
        <p className="m-0 flex items-center gap-1 text-label font-medium text-violet-600 [&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0">
          <InfoIcon />
          <span>개인을 알아볼 수 있는 정보는 적지 말아주세요.</span>
        </p>
        <p className="m-0 flex items-baseline gap-px text-body-sm font-medium whitespace-nowrap">
          <span className="leading-[1.6] text-violet-900">{draft.rawText.length}</span>
          <span className="leading-[1.32] text-[#989898]">{`/${RAW_TEXT_MAX}`}</span>
        </p>
      </div>
      </div>
    </section>
  )
}
function RevisionNotice({ onClose }: { onClose: () => void }) {
  return (
    <div className="flex items-center gap-2 rounded-xl border border-white-400 bg-white-50 px-2.5 py-1.5 drop-shadow-[0_0_6px_rgba(0,0,0,0.12)]">
      <span className="shrink-0 text-[#f54550]" aria-hidden>
        <AlertIcon />
      </span>
      <p className="m-0 min-w-0 flex-1 text-label font-medium text-black-700">
        도움이 필요한 대상이 누구인지, 어떤 도움이 필요한지 상세하게 작성해주세요.
      </p>
      <button
        type="button"
        className="ui-pressable ui-pressable--circle flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded-md border-0 bg-none p-0 text-black-600 [&>svg]:h-4 [&>svg]:w-4"
        aria-label="안내 닫기"
        onClick={onClose}
      >
        <XCloseIcon />
      </button>
    </div>
  )
}
